import { AHSeparator, ListItem, useBoxStyle } from "arkh";
import React from "react";
import { FlatList } from "react-native";
import { useLazyLoadQuery, graphql } from "react-relay";

import { LazyQueryNetworkBoundrary } from "../../../components/mobile/QueryNetworkBoundrary";

import { useModalInsets } from "../../../components/mobile/useModalInsets";
import { KPIAdminTeamHeader } from "../components/KPIAdminTeamHeader";
import { KPICreateAdminTeamQuery } from "./__generated__/KPICreateAdminTeamQuery.graphql";
import { KPICreateParams } from "./KPICreateParams";

const KPI_CREATE_ADMIN_TEAM_QUERY = graphql`
  query KPICreateAdminTeamQuery {
    currentStore @required(action: THROW) {
      publicTeams {
        id
        color
        icon
        name
        ...ListItemTeamIndicator_team
      }
    }
  }
`;

export function KPIAdminCreateAdminTeam(props: {
  onNext: (adminTeam: KPICreateParams["adminTeam"]) => void;
}) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <InnerKPIAdminCreateAdminTeam {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerKPIAdminCreateAdminTeam(props: {
  onNext: (adminTeam: KPICreateParams["adminTeam"]) => void;
  fetchKey: string;
}) {
  const data = useLazyLoadQuery<KPICreateAdminTeamQuery>(
    KPI_CREATE_ADMIN_TEAM_QUERY,
    {},
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  const insets = useModalInsets();

  const contentContainerStyle = useBoxStyle({
    space: "medium",
    insets,
  });
  return (
    <FlatList
      contentInsetAdjustmentBehavior="always"
      ItemSeparatorComponent={AHSeparator}
      ListHeaderComponent={KPIAdminTeamHeader}
      contentContainerStyle={contentContainerStyle}
      data={data.currentStore.publicTeams ?? []}
      renderItem={({ item, index }) => {
        return (
          <ListItem
            onPress={() => {
              props.onNext({
                color: item.color,
                icon: item.icon as any,
                id: item.id,
                name: item.name,
              });
            }}
            isFirst={index === 0}
            border="border-primary"
            isLast={index === data.currentStore.publicTeams.length - 1}
            left={<ListItem.TeamIndicator team={item} />}
            right={<ListItem.NavArrow />}
          >
            <ListItem.Title>{item.name}</ListItem.Title>
          </ListItem>
        );
      }}
    />
  );
}
